import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { StateService } from 'src/app/services/states.service';
import { AppService } from 'src/app/services/app.service';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { debounce, filter, first } from 'rxjs/operators';
import { Subject, timer } from 'rxjs';
import { ShowRapportsArchivDialog } from '../dialogs-show-file/show-rapports-archiv-dialog.component';
import { MessDelete } from '../dialogs-messages/mess_delete_dialog.component';
import { MatDialog, MatStepper } from '@angular/material';
import { LoginComponent } from '../../partials/login/login.component';
import { DialogsDuplicationComponent } from '../dialogs-duplication/dialogs-duplication.component';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { DialogDossierLabelComponent } from '../dialogs/dialog-dossier-label/label.component';
import { updateDossierService } from 'src/app/services/Dossier/updateDossier.service';
import { truncateSync } from 'fs';

@Component({
  selector: 'app-dossier',
  templateUrl: './dossier.component.html',
  styleUrls: ['./dossier.component.scss']
})
export class DossierComponent implements OnInit {
  dossiers:any = [];
  sortDoss:any;
  sortActiv:any;
  filters:any = {
    search : "",
    sortActivity : "Actif",
    sortConsultation : "All",
    sortDossier : "Date"
  }
  currentUser:any;

  delaySearch:any;
  searchOk = false;
  headElements = ['Nom','Prénom', 'Entreprise', 'Date de création', 'Dupliqué', 'Date d\'archivage', ' '];
  page= 1;
  pageSize=6;
  messageDelete:boolean = false;
  dossierDelete:any;
  classButton: any = "elem-action-doss";

  errorHandlingMessage:string = ''

  @ViewChild('stepper', {static : true}) private myStepper: MatStepper;
  subscribe: any = [];
  tokenauth = "";

  eventDossierComparateur: Subject<any> = new Subject<any>();
  eventRemoveDossierComparateur: Subject<any> = new Subject<any>();
  eventUpdateDossierComparateur: Subject<any> = new Subject<any>();

  constructor(
    public stateService: StateService,
    public appService: AppService,
    private router: Router,
    public dialog: MatDialog,
    private cdf: ChangeDetectorRef,
    private cookies: CookieService,
    private updateDossierService: updateDossierService
  ) { }

  ngOnInit() {
    if (!this.stateService.user.getValue()) {
        environment.tokenauth = this.cookies.get("Tokenauth");
        if(environment.tokenauth){
            this.appService.getUserByToken(this.tokenauth).subscribe((res) => {
                if(res.result.user){
                    environment.tokencalc = res.result.token_calc;
                    res.result.user.identity.ID = res.result.user.ID;
                    res.result.user.identity.email = res.result.user.connection.email;
                    this.stateService.updateUser(res.result.user.identity);
                    this.currentUser = res.result.user.identity;
                    this.fetchData();
                } else {
                    this.router.navigateByUrl("/homepage");
                }
            });
        }
    } else {
        this.currentUser = this.stateService.user.getValue();
        this.fetchData();
    }
  }
  errorHandling(response){
    if(response.error){
      this.errorHandlingMessage = response.error
      
      if(response.code){
        let dialogRef = this.dialog.open(LoginComponent, {
          height: '55%',
          width: '25%',
          panelClass:'dialog-login'
        })
      }

    }
  }

  fetchData(){
    window['tryga']('send', 'event', 'dossier', '', '', '');
    this.stateService.updateDossier("");
    if(this.subscribe && this.subscribe['stateService']){
      this.subscribe['stateService'].unsubscribe();
    }
    // this.subscribe['stateService'] = this.stateService.user.subscribe((user) => {
    //     this.currentUser = user;
      if(this.currentUser) {
        if (this.router.url.startsWith("/dossier/archive")) {
            console.log('ARCHIVE')
            this.filters.sortActivity = 'Archive'
        }
        this.delaySearch = this.appService.getDossiersById(this.currentUser.ID, this.filters)
                              .pipe(first(),debounce(() => timer(1000)));
        if(this.subscribe && this.subscribe['getDossiersById']){
          this.subscribe['getDossiersById'].unsubscribe();
        }
        this.subscribe['getDossiersById'] = this.appService.getDossiersById(this.currentUser.ID, this.filters).subscribe((res) => {
          if(res.result.error && res.result.code){
            this.errorHandling(res.result)
          }else if (res.result && res.result.datas) {
            this.dossiers = res.result.datas;
            this.setDateFinLastBs();
            this.dossiers.forEach(element => {
                if (this.filters.sortActivity != 'Archive') {
                    element.etat = "1";
                }
            });
            this.searchOk =true;
          } 
        });
      }
    // })
  }

  updateDossier(dossier: any, resultats = false) {
    if (!dossier) {
      this.router.navigateByUrl("/dossier/post/", {state: {resultats: false}});
    } else if(dossier.etatvalidation && dossier.etatvalidation < 4 && dossier.isDelegation){
      window['tryga']('send', 'event', 'espace_dossiers', 'consulter', '', '');
      this.router.navigateByUrl("/dossier/post/"+dossier.displayID, {state: {fillDelegationForm: true}});
    }
    else if(dossier.etatvalidation && dossier.etatvalidation > 4 && resultats === true){
      window['tryga']('send', 'event', 'espace_dossiers', 'consulter', '', '');
      this.router.navigateByUrl("/dossier/post/"+dossier.displayID, {state: {resultats: true}});
    // }
    // else if(dossier.etatvalidation && dossier.etatvalidation < 4){
    //   window['tryga']('send', 'event', 'espace_dossiers', 'completer', '', '');
    //   this.router.navigateByUrl("/dossier/add/false/"+dossier.displayID);
    }else{
      window['tryga']('send', 'event', 'espace_dossiers', 'calculer', '', '');
      this.router.navigateByUrl("/dossier/post/"+dossier.displayID);
    }
  }

  archiveDossier(dossier: any){
    window['tryga']('send', 'event', 'espace_dossiers', 'archiver', '', '');
    if(this.subscribe && this.subscribe['archiveDossier']){
      this.subscribe['archiveDossier'].unsubscribe();
    }
      this.subscribe['archiveDossier'] = this.appService.archiveDossier(dossier.id).subscribe((res)=>{
/*
      if(res.result && res.result.dossier){
        dossier = res.result.dossier;
      }
*/
      this.searchDossier();
    });

  }

  duplicateDossier(dossier: any){
    window['tryga']('send', 'event', 'espace_dossiers', 'dupliquer', '', '');
    if(this.subscribe && this.subscribe['duplicateDossier']){
      this.subscribe['duplicateDossier'].unsubscribe();
    }
    let modalTitle = "Merci de saisir un identifiant unique pour la copie de votre dossier";
    this.openChangeDossierLabel(dossier, modalTitle, true).afterClosed().subscribe((result) => {
      if(result.saved) {
        let label = result.label ? result.label : "";
        const dialogRef = this.dialog.open(DialogsDuplicationComponent, {
          width: '100%',
          panelClass:'message-dialog-supp',
          disableClose: true
        });
        this.subscribe['duplicateDossier'] = this.appService.duplicateDossier(dossier.id).subscribe((res)=>{
            dialogRef.close();
          if(res.result && res.result.displayID){
            this.updateDossierService.setDossierLabel(res.result.id, label)
              .subscribe((response) => {})
            this.router.navigateByUrl("/dossier/post/"+res.result.displayID);
          }
        })
      }
    });
  }

    duplicateArchivedFolder(folderId) {
        // window['tryga']('send', 'event', 'espace_archives', 'dupliquer', '', '');
        if(this.subscribe && this.subscribe['duplicateDossierArchive']){
            this.subscribe['duplicateDossierArchive'].unsubscribe();
        }
        const dialogRef = this.dialog.open(DialogsDuplicationComponent, {
            width: '100%',
            panelClass:'message-dialog-supp',
            disableClose: true
        });
        this.subscribe['duplicateDossierArchive'] = this.appService.duplicateDossier(folderId).subscribe((res)=>{
            if (res.result && res.result.id) {
                this.appService.changeEtatValidationDossier(res.result.id, 1).subscribe((data) => {
                    dialogRef.close();
                    if(data.result && data.result.dossier && data.result.dossier.displayId){
                        // this.router.navigateByUrl("/dossier/add/" + false + "/" + data.result.dossier.displayId);
                        this.router.navigateByUrl("/dossier/post/" + data.result.dossier.displayId);
                    }
                })
            }
        })
    }

  deleteDossier(dossier: any){
    window['tryga']('send', 'event', 'espace_dossiers', 'supprimer', '', '');
    const dialogRef = this.dialog.open(MessDelete, {
      width: '100%',
      panelClass:'message-dialog-supp',
      data: dossier
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result.event && result.event === 3){
        this.removeFromComparateur(dossier);
        this.appService.deleteDossier(dossier.id).subscribe((res)=>{
              this.searchDossier();
            })
      }
    });
  }

  searchDossier(type = null) {
	if (type != null) {
      window['tryga']('send', 'event', 'espace_dossiers', type, '', '');
	}
  if(this.subscribe && this.subscribe['delaySearch']){
    this.subscribe['delaySearch'].unsubscribe();
  }
    this.subscribe['delaySearch'] = this.delaySearch.subscribe((res) => {
      console.log(res)
      if(res.result.error && res.result.code){
        this.errorHandling(res.result)
      }else if(res.result && res.result.datas){
        this.dossiers = res.result.datas;
        this.setDateFinLastBs();
      }
    });
  }

  viewDossier(iddossier){
    if(this.subscribe && this.subscribe['getDossierRapport']){
      this.subscribe['getDossierRapport'].unsubscribe();
    }
      this.subscribe['getDossierRapport'] = this.appService.getDossierRapport(iddossier).subscribe((res)=>{
      if( res.result && res.result.rapport){
        let panelClass = 'viewrapport-dialog'
        if(res.result.rapport.length == 0)
          panelClass = 'viewrapport-dialog-null'
        const dialogRef = this.dialog.open(ShowRapportsArchivDialog, {
          width: '100%',
          maxWidth:'100%',
          panelClass: panelClass,
          data: {'rapports': res.result.rapport,'iddossier':iddossier}
        });
      }
    })
  }

  setDateFinLastBs() {
    this.dossiers.forEach(doss => {
      let strDateBrut = doss.bulletinSalaire.reduce(function(accumulator, currentValue) {
        if (currentValue.valide == 1 && currentValue.datefinbs ) {
          let currentDateString = currentValue.datefinbs.split('T')[0];
          if (accumulator == '') {
            return currentDateString;
          } else {
            let accDate = new Date(accumulator);
            let currentDate = new Date(currentValue.datefinbs);
            if (currentDate > accDate) {
              return currentDateString;
            } else {
              return accumulator;
            }
          }
        } else {
          return accumulator;
        }
      }, '');
      if (strDateBrut) {
        let date = new Date(strDateBrut);
        doss.dateFinLastBs = (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) + '/' + (date.getMonth() > 8 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + date.getFullYear();
      }
    });
  }

  ngOnDestroy(){
    this.cdf.detach()
    for(let element in this.subscribe){
        this.subscribe[element].unsubscribe();
        this.subscribe[element] = null;
    }
  }

  addToComparateur(dossier)
  {
    this.eventDossierComparateur.next(dossier);
  }

  removeFromComparateur(dossier)
  {
    this.eventRemoveDossierComparateur.next(dossier);
  }

  updateDossierComparateur(dossier)
  {
    this.eventUpdateDossierComparateur.next(dossier);
  }


  openChangeDossierLabel(dossier, title = "", duplication = false)
  {
    const dialogRef = this.dialog.open(DialogDossierLabelComponent, {
      width: '50%',
      maxWidth:'50%',
      data: {
        "title": title,
        "dossier": dossier,
        "duplication": duplication
      }
    });
    return dialogRef;
  }

  changeDossierLabel(dossier)
  {
    this.openChangeDossierLabel(dossier).afterClosed().subscribe(result => {
      if(result.label && result.saved){
        dossier.dossier_label = result.label;
        this.cdf.detectChanges();
        this.updateDossierComparateur(dossier);
      }
    });
  }

  isInDossiersToCompare(dossier)
  {
    let dossiersToCompare = JSON.parse(localStorage.getItem("dossiersComparaison"));
    return dossiersToCompare ? dossiersToCompare.find(x => x.id == dossier.id) != undefined : false;
  }
}
